module.exports = __webpack_public_path__ + "static/media/Евтина Д, Жабко А. (ДУ).f7f6e16f.pdf";